import {api} from "../../../../api/API";
import {useEffect, useState} from "react";
import {getAll, useGetAll} from "../../../logistics/routes/useGetAll";
import {wasteEmitter} from "./Logistics";
import {WasteReport} from "../../../../api/Logistics";
import {BoolCol, NumberCol, StringCol, Table, ViewOnly} from "../../../../misc/scroller/Table";
import {projectTablePrefName} from "../TablePrefName";
import {WasteReportItem} from "./WasteReportItem";
import {DateFilterCol} from "../../../../misc/DateFilterForCol";

export function wasteTableName(project: number) {
    return projectTablePrefName("project.logistics.waste", project)
};

export function Waste(props: {
    project?: number;
}) {

    const project = props.project;
    const list = useGetAll(input => api.logistics.listWasteProducts(input), {includeReviewed: false, project}, [project]);

    useEffect(() => {
        wasteEmitter.emit({count: list.asList.length});
    }, [list.asList.length]);

    const [selection, setSelected] = useState<WasteReport>();

    return (
        <>
            {selection ? <WasteReportItem value={selection} onCancel={() => setSelected(undefined)} onComplete={() => {
                    list.reload();
                    setSelected(undefined);
            }} /> :
                <div style={{flex: 1, display: "flex", backgroundColor: "white"}}>
                    <Table<WasteReport>
                        name={wasteTableName(props.project || 0)}
                        fetch={ctx => getAll(ctx, offset => api.logistics.listWasteProducts({
                            project: props.project,
                            includeReviewed: !!props.project,
                            offset: offset
                        }))}
                        fetchDeps={[props.project]}
                        columns={[
                            DateFilterCol<WasteReport>("Created At", "createdAt", "YYYY-MMM-D", 100),
                            ViewOnly(StringCol("PO #", "poNumber", 100)),
                            ViewOnly(StringCol("Product", "productName", 400)),
                            ViewOnly(StringCol("Manufacturer", "manufacturerName", 120)),
                            ViewOnly(NumberCol("Qty", "qty", 50)),
                            ViewOnly(BoolCol("Reviewed", "reviewed", 50)),
                        ]}
                        onRowClick={setSelected}
                        onChange={input => noop()}
                    />
                </div>
            }
        </>
    );
}

function noop() {
    return Promise.reject(new Error("not supported"));
}